module.exports = __webpack_public_path__ + "static/media/backgroundImage.e2de404b.png";